import { Typography } from "@mui/material";
import { InfoCompanyContainer } from "../../styles/infoCompany";

export function InfoCompany() {
  return (
    <>
    <InfoCompanyContainer>
      <Typography variant={"h2"} style={{fontWeight: 'bold', padding: '2%'}}>Our purpose</Typography>
      <Typography variant="h5" style={{padding: '2%'}}>
        When our health is at risk, we rely on physicians to make the best
        possible decisions - from quick, early diagnoses to the most effective
        treatments and follow-ups. By constantly bringing breakthrough
        innovations to market, we help healthcare professionals to deliver
        high-quality care, leading to the best possible outcome for patients.
      </Typography>
      <Typography variant="h5" style={{padding: '2%'}}>
        Our portfolio of is at the center of clinical decision-making and
        treatment pathways. Patient-centered innovation has been and always will
        be at the core of our company. We aspire to create better outcomes and
        experiences for patients no matter where they live or what they are
        facing.
      </Typography>
      <Typography variant="h4" style={{fontWeight: 'bold', padding: '2%' }}>
        We pioneer breakthroughs in healthcare. For everyone. Everywhere.
      </Typography>

      <Typography variant="h6" style={{padding: '2%'}}>
        This is why we give our best every day, to improve the lives of patients
        and their families.
      </Typography>
    </InfoCompanyContainer>
    </>
  );
}
